/**
 * Copyright (c) 2022 Interacso
 * All rights reserved.
 */

 import React from "react";
 import Player from "./Player";
 
 function InteractivePlayer({ params }) {
    const { creativeId } = params
 
   if (creativeId) {
     return <Player creativeId={creativeId} />;
   }
 
   return null;
 }
 
 export default InteractivePlayer;
 